// File status values as stored by the upload session API
export const UPLOAD_STATUS = {
  PENDING: 'PENDING',
  UPLOADING: 'UPLOADING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const uploadStatusConfig = {
  [UPLOAD_STATUS.UPLOADING]: { label: 'Uploading', color: '#246bfd', background: '#e3efff', bar: '#377ff0' },
  [UPLOAD_STATUS.PENDING]: { label: 'Queued', color: '#64748b', background: '#edf1f7', bar: '#377ff0' },
  [UPLOAD_STATUS.COMPLETED]: { label: 'Completed', color: '#16a34a', background: '#e2f7e9', bar: '#35c56f' },
  [UPLOAD_STATUS.FAILED]: { label: 'Failed', color: '#ef4444', background: '#ffe8e8', bar: '#f5a6a6' },
};

// Upload session status values returned by GET records/v4/data-room/uploads/
export const SESSION_STATUS = {
  ACTIVE: 'ACTIVE',
  // Display only: files still being registered in this tab
  PREPARING: 'PREPARING',
  // Display only: ACTIVE but not being uploaded anywhere
  INTERRUPTED: 'INTERRUPTED',
  // Display only: paused in this tab
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
};

export const sessionStatusConfig = {
  [SESSION_STATUS.ACTIVE]: { label: 'In Progress', color: '#246bfd', background: '#e3efff', bar: '#377ff0' },
  [SESSION_STATUS.PREPARING]: { label: 'Preparing to upload', color: '#246bfd', background: '#e3efff', bar: '#377ff0' },
  [SESSION_STATUS.INTERRUPTED]: { label: 'Interrupted', color: '#b45309', background: '#fef3c7', bar: '#f0b429' },
  [SESSION_STATUS.PAUSED]: { label: 'Paused', color: '#475569', background: '#e2e8f0', bar: '#94a3b8' },
  [SESSION_STATUS.COMPLETED]: { label: 'Completed', color: '#16a34a', background: '#e2f7e9', bar: '#35c56f' },
  [SESSION_STATUS.FAILED]: { label: 'Failed', color: '#ef4444', background: '#ffe8e8', bar: '#f5a6a6' },
  [SESSION_STATUS.CANCELLED]: { label: 'Cancelled', color: '#64748b', background: '#edf1f7', bar: '#cbd5e1' },
};
